import { render, staticRenderFns } from "./GroupBox.vue?vue&type=template&id=d83b8b7c&"
import script from "./GroupBox.vue?vue&type=script&lang=ts&"
export * from "./GroupBox.vue?vue&type=script&lang=ts&"
import style0 from "./GroupBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports